import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {FormattedMessage} from "react-intl";
import $ from "jquery";

import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Button from "@mui/material/Button";

import {setLookLockedTutorial} from "../../../../actions/lookFunctions";
import {getLookRowHeight} from "../../lookNavigation/lookMain/lookCategory/lookVirtualizedList";

const LookLockTutorialModal = (props) => {

  const {lookLockedTutorial, setLookLockedTutorial, hideOverlay, anchorEl, withGrid, fabricatorData, lookViewType,
    isMobile, wizardActiveItem} = props;

  if (!anchorEl || !anchorEl.current) {
    return null
  }

  const {step, firstUnlockedIndex} = lookLockedTutorial;

  const nextButtonClick = () => {
    if (step === 1) {
      setLookLockedTutorial({step: 2})
    } else {
      if (Number.isInteger(firstUnlockedIndex)) {
        const scrollSelector = isMobile
          ? ".lm-content--no-scroll " + (withGrid ? ".ReactVirtualized__Grid" : ".lm-content")
          : ".lm-section:not(.lm-section--hidden) " + (withGrid ? ".ReactVirtualized__Grid" : ".lm-content");
        const scrollDiv = document.querySelector(scrollSelector);
        if (scrollDiv) {
          $(scrollDiv).animate({scrollTop: (firstUnlockedIndex * getLookRowHeight(lookViewType)) - 30}, 800);
        }
      } else {
        const firstLockedElem = document.querySelector(".lm-feature--unlocked");
        const scrollDiv = firstLockedElem ? firstLockedElem.closest(withGrid ? ".ReactVirtualized__Grid" : ".lm-content") : null;
        if (scrollDiv) {
          $(scrollDiv).animate({scrollTop: firstLockedElem.offsetTop - 30}, 800);
        }
      }
      hideOverlay(() => {
        setLookLockedTutorial({
          visible: false,
          step: 0,
          finished: true
        });
      });
    }
  }

  return (
    <Popper open={step > 0}
            className={"look-lock__mod" + (wizardActiveItem ? " look-lock__mod--wizard" : " lk-title__modal")}
            id={"style-modal"}
            anchorEl={anchorEl.current}
            placement={"right"}
            transition
            disablePortal={false}>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          // style={{ transformOrigin: isMobile ? "top center" : "left center" }}
          style={{ transformOrigin: "left center" }}
        >
          <Paper className="lk-title__modal-paper">
            {step ? (
              <div  className="lk-title__modal-paper-content look-lock__modal">
                <div className="look-lock__modal-content">
                  <h3 className="h3">
                    <FormattedMessage id={"look.lockedOverlay.step"+step+".title"}/>
                  </h3>
                  <p className="look-lock__modal-content-text">
                    <FormattedMessage id={"look.lockedOverlay.step"+step+".text"}/>
                  </p>
                </div>
                <p className="text-right look-lock__modal-button">
                  <Button className={"look-button " + (fabricatorData.isAmericanStandard
                    ? "look-button--primary2" : "look-button--primary look-button--yellow")}
                          onClick={nextButtonClick}>
                    <FormattedMessage id={"look.lockedOverlay.step"+step+".button"}/>
                  </Button>
                </p>
              </div>
            ) : null}
          </Paper>
        </Grow>
      )}
    </Popper>
  )
};

LookLockTutorialModal.propTypes = {
  anchorEl: PropTypes.any,
  hideOverlay: PropTypes.func,
  withGrid: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {lookLockedTutorial, lookViewType} = store.lookState;
  const fabricatorData = store.fabricatorState;
  const {isMobile} = store.serverState;
  const {wizardActiveItem} = store.wizardState;

  return {
    lookLockedTutorial,
    fabricatorData,
    lookViewType,
    isMobile,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
  setLookLockedTutorial
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookLockTutorialModal)
)
